import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { AppConfigService } from '../../services/app-config.service';
import { Observable } from 'rxjs';

export class CompteInfo {
  compteKey: number;
  login: string;
  role: string;
  actif: boolean;
  cgu: boolean;
  accepteMail: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class AdminService {
  private apiUrl: string;

  constructor(private _http: HttpClient, private _appConfig: AppConfigService) {
      this.apiUrl = _appConfig.config.servicesBaseUrl;
  }

  getAdminByCptKey(compteKey: string): Observable<HttpResponse<any>> {
    const apiUrl = this._appConfig.config.servicesBaseUrl;
    let params = new HttpParams();
    return this._http.get<any>(apiUrl + `/adm/` + compteKey, { params, observe: 'response' });
  }
}
